import '../../../styles/Empty.css';
import { EmptyProps } from './Empty.types';

export default ({ isFullscreen, children }: EmptyProps) => {
  if (isFullscreen)
    return (
      <div className="empty-fullscreen" data-testid="empty-fullscreen">
        <div className="empty">
          <p className="empty__text">{children}</p>
        </div>
      </div>
    );
  return (
    <div className="empty">
      <p className="empty__text">{children}</p>
    </div>
  );
};
